export default __webpack_public_path__ + "static/media/FedEx_Logo.c7fabdfb.svg";